
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import './bootstrap.css';
import './App.scss';

import Navbar from './components/Navbar';

import Hero from './components/Hero';

import HighlightText from './components/HighlightText';

import Impact from './components/impact';

import Process from './components/process';

import CaseStudies from './components/CaseStydies';

// import Team from './components/Team';

// import Contact from './components/Contact';

import Footer from './components/Footer';
function App() {
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const duration = 5000;
    const startTime = Date.now();
    const interval = window.setInterval(() => {
      const elapsed = Date.now() - startTime;
      const nextProgress = Math.min(100, Math.round((elapsed / duration) * 100));
      setProgress(nextProgress);

      if (nextProgress >= 100) {
        window.clearInterval(interval);
        setIsExiting(true);
        window.setTimeout(() => setLoading(false), 700);
      }
    }, 50);

    return () => window.clearInterval(interval);
  }, []);

  return (
    <div className="view-port">
      {loading && (
        <div className={`preloader ${isExiting ? 'preloader--exit' : ''}`}>
          <div className="preloader__percent">{progress}%</div>
        </div>
      )}
      <Helmet>
        <title>Sujam Shrestha - Creative Head, Graphic & UI/UX Designer</title>
        <meta charset="UTF-8" />
        <meta name="description" content="Sujam Shrestha, a Creative Head with over 11 years of experience in graphic design, product design, logo design, UI/UX design, and mentoring. Engaged with Swivt Technologies." />
        <meta name="keywords" content="Sujam Shrestha, Graphic Design, Product Design, Logo Design, UI/UX Design, Swivt Technologies, Mentor, Creative Head" />
        <meta name="author" content="Sujam Shrestha" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <meta property="og:title" content="Sujam Shrestha - Creative Head, Designer & Mentor" />
        <meta property="og:description" content="Explore the portfolio and work of Sujam Shrestha, a Creative Head with expertise in graphic design, product design, and UI/UX design." />
        <meta property="og:image" content="URL to your portfolio image" />
        <meta property="og:url" content="https://suzamb.com.np" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Sujam Shrestha - Creative Head & Design Mentor" />
        <meta name="twitter:description" content="With 11+ years of experience, Sujam Shrestha is a creative head specializing in design leadership and mentoring." />
        <meta name="twitter:image" content="URL to your portfolio image" />
        <link rel="apple-touch-icon" href="/logo192.png" />
        <link rel="manifest" href="/manifest.json" />
      </Helmet>
      <Navbar />
      <Hero />
      <HighlightText />
      <Impact />
      <Process />
      <CaseStudies />
      <Footer />
    </div>
  );
}



export default App;
